import { render } from "./AddPaymentModal.vue?vue&type=template&id=20ff33e3&scoped=true"
import script from "./AddPaymentModal.vue?vue&type=script&lang=js"
export * from "./AddPaymentModal.vue?vue&type=script&lang=js"

import "./AddPaymentModal.vue?vue&type=style&index=0&id=20ff33e3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ff33e3"]])

export default __exports__